export const getIsProductionEnvironment = () => {
  if (typeof window === "undefined") {
    return false;
  }

  const { host } = new URL(window.location.href);
  return host.includes("app.testaviva.dk");
};

export const getIsStagingEnvironment = () => {
  if (typeof window === "undefined") {
    return false;
  }

  const { host } = new URL(window.location.href);
  return host.includes("app.staging.testaviva.dk");
};
